const getSectorNames = (sector = []) => sector.map((s) => s.name);

export default getSectorNames;
